import {DataSource} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

export class datosGrid {
  dataChange: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  get data(): any[] { return this.dataChange.value; }

  constructor(private datos:any) {
     this.dataChange.next(this.datos);
  }
}

export class DataSourceGrid extends DataSource<any> {
  constructor(private _exampleDatabase: datosGrid) {
    super();
  }

  connect(): Observable<any[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice();
      return data;
    });
  }

  disconnect() {}
}


// WEBPACK FOOTER //
// ./src/app/utils/llenarGrid.component.ts